import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { MechanismSection } from './components/MechanismSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { ForWhoSection } from './components/ForWhoSection';
import { AuthorSection } from './components/AuthorSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ReviewsSection } from './components/ReviewsSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { LivePurchaseNotification } from './components/LivePurchaseNotification';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="font-sans antialiased text-white bg-dark min-h-screen pt-[36px]" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <ModulesSection data-id="element-7" />
        <BonusSection data-id="element-8" />
        <ForWhoSection data-id="element-9" />
        <AuthorSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <ReviewsSection data-id="element-12" />
        <PricingSection data-id="element-13" />
        <FaqSection data-id="element-14" />
        <FinalCtaSection data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <FloatingCta data-id="element-17" />
      <LivePurchaseNotification data-id="element-18" />
    </div>;
}